import * as core from '../../../../../../../core'

import { query } from './explore-perf-comparison.query'

export const RESOURCE = {
  payload: {
    alias: 'rp.explore.widgets.comparative-performance',
    description:
      'Version of Comparative Performance that accounts for Institution, Organization, and PI Lenses',
    name: 'RP Explore - Comparative Performance',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
